import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { tagDriverFactory } from './Tag.driver';
import { Tag, TagProps } from '.';

describe('Tag', () => {
  const createDriver = createRendererWithUniDriver(tagDriverFactory);

  const bootstrap = (props: Partial<TagProps> = {}) => {
    return createDriver(<Tag {...props}>Tag Name</Tag>);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  describe('close icon', () => {
    it('should be rendered', async () => {
      const { driver } = bootstrap({
        isRemovable: true,
      });

      expect(await driver.hasCloseIcon()).toBeTruthy();
    });

    it('should not be rendered', async () => {
      const { driver } = bootstrap({
        isRemovable: false,
      });

      expect(await driver.hasCloseIcon()).toBeFalsy();
    });
  });

  describe('interactive behaviour', () => {
    it('should call onRemove prior to onClick handler', async () => {
      const props = {
        isRemovable: true,
        onRemove: jest.fn(),
        onClick: jest.fn(),
      };
      const { driver } = bootstrap(props);
      await driver.clickRemoveButton();
      expect(props.onRemove).toHaveBeenCalled();
      expect(props.onClick).not.toHaveBeenCalled();
    });

    it('should call onClick prior to onRemove handler', async () => {
      const props = {
        isRemovable: false,
        onRemove: jest.fn(),
        onClick: jest.fn(),
      };
      const { driver } = bootstrap(props);
      await driver.clickRemoveButton();
      expect(props.onRemove).not.toHaveBeenCalled();
      expect(props.onClick).toHaveBeenCalled();
    });
  });
});
